import { ArrowRightIcon } from '../Icons/ArrowRightIcon';

type TScheduleTextProps = {
    value: string;
    content: string;
    handler: (value: string) => void;
};

export const ScheduleText = ({ value, content, handler }: TScheduleTextProps) => {
    return (
        <li className="relative mb-3 w-full" data-test-id="schedules-item">
            <button
                type="button"
                className="tx-large-semibold flex h-[65px] w-full items-center justify-between gap-x-1 overflow-hidden rounded-2xl border border-gray-2 pl-4 pr-3 text-gray-2 dark:border-gray-3 dark:text-gray-3"
                onClick={() => handler(value)}
            >
                {content}
                <div className="z-[1] flex h-[34px] w-[18px] items-center justify-center bg-white shadow-[0_0_16px_16px_rgba(255,255,255,1)] dark:bg-dark-3 dark:shadow-[0_0_16px_16px_rgba(41,56,71,1)]">
                    <ArrowRightIcon className="h-[50%] w-[50%] [&_path]:fill-gray-3" />
                </div>
            </button>
        </li>
    );
};
